<app-website-header></app-website-header>

    <div class="d-flex align-items-center justify-content-center header-body">
        <div class="header header-m" >Who We Are</div>
        <div class="header-description header-description-m">Medworld Expo is a pioneering digital platform transforming medical equipment exhibitions,
            connecting stakeholders to enhance industry engagement and innovation.</div>
    </div>

    <div class="about-us-img" >
        <img  class="about-us-banner" src="/assets/images/about-us-banner.jpg" alt="about-us-banner" width="100%" height="auto" style="padding-right:80px;padding-left: 40px;">
    </div>

    <div class="d-flex align-items-center justify-content-center gap-4 about-us-section2"  >
        <div class=".ceo-note-div">
        <p class="meet-our-team-header header-m" style="margin-bottom: 29px;">CEO's Message</p>
        <p class="ceo-note header-description-m" style="width:600px;" > At Medworld Expo, we recognized the need for a modern, efficient platform to bridge the gap in medical equipment exhibitions.
             Our goal is to empower OEMs,
             Distributors, and healthcare providers by providing an innovative space for collaboration, learning, 
            and growth. We believe this platform will redefine how the industry engages and thrives, 
            ultimately enhancing healthcare delivery worldwide.
        </p>
        <p class="ceo-note header-description-m" style="width:600px;" >
                As the healthcare landscape evolves, we are committed to creating a digital ecosystem where innovation, 
            trust, and global connectivity come together. Medworld Expo isn't just a marketplace—it's a hub for 
            fostering meaningful partnerships, advancing medical technology, and driving the future of healthcare."
        </p>
        </div>
      <div>
        <img class="about-us-mission" src="../../../../assets/images/woman-with-pen (1).jpg" alt="about-us-mission" width="300px" height="450px">
        
        </div>
      <!-- <div>
        <img class="about-us-mission" src="/assets/images/shaking-hands.jpg" alt="about-us-mission" width="300px" height="450px"> 
        </div> -->
    </div>
    
    <!-- <div class="d-flex flex-column align-items-center justify-content-center gap-4 about-us-section2" >
    <div class="meet-our-team-header header-m" style="margin-bottom: 15px;margin-top: 15px;">Meet Our Mentors</div>

    <div class="meet-our-team-img" >
        <div>
            <img class="mentors-img" src="/assets/images/meet_our_team.jpg" alt="about-us-mission" width="310px" height="500px">
        </div>
        <div>
            <img class="mentors-img" src="/assets/images/meet_our_team.jpg" alt="about-us-mission" width="310px" height="500px">
        </div> 
    <div>
        <img class="mentors-img" src="/assets/images/meet_our_team.jpg" alt="about-us-mission" width="310px" height="500px">
    </div>   
    </div>
    </div> -->

    <div class="d-flex flex-column align-items-center justify-content-center gap-4 about-us-section3" >
        <div class="meet-our-team-header mt-4 header-m our-process" >Our Process</div>
        
        <div class="d-flex flex-column align-items-center justify-content-center our-process-tabs mt-2">
            <div class="d-flex justify-content-center align-items-center process ">
               <div class="d-flex  justify-content-center align-items-center offering-item" >
                <div class="container">
                    <div >
                        <div class="number common-number">1</div>
                        <div class="img-offering-tab img-offer-align">
                        <p class="offering">User Registration
                            </p>
                        <p class="offering-p"> Sign up easily and create your profile.</p>
                    </div></div>
                </div>
                <img src="/assets/images/sign-user-password-privacy-concept (1).jpg" alt="about-us-mission" width="300px" height="290px" class="process-img">
               </div>
               
                    <div class="container">
                    <div class="offering-item " style="width:414px;" >       
                        <div class="offering-item-tab two">
                            <div class="number two-number common-number">2</div>
                            <div class="img-offering-tab img-offer-align">
                                <p class="offering">Product Listing</p>
                                <p class="offering-p">  OEMs and Distributors showcase their offerings.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="/assets/images/young-male-worker-uniform-is-warehouse-with-notepad-pen (1).jpg" alt="about-us-mission" width="300px" height="290px" class="d-md-none d-lg-none process-img">
            
            </div>
            
            <div class="d-flex justify-content-center align-items-center process ">
                <div class="container">
                    <div class="offering-item ">
                        <div class="offering-item-tab two">
                        <div class="number three-number common-number">3</div>
                        <div class="three-txt img-offer-align" style="width:350px;">
                        <p class="offering">Networking Opportunities </p>
                        <p class="offering-p"> Connect with healthcare professionals and organizations.</p>
                    </div></div>
                </div>
                </div>
                <img src="/assets/images/side-view-positive-business-people-handshake (1).jpg" alt="about-us-mission" width="300px" height="290px" class="d-md-none d-lg-none process-img">

            
                <div class="d-flex  justify-content-center align-items-center offering-item " >
                    <div class="container">
                        <div >
                            <div class="number common-number">4</div>
                            <div class="img-offering-tab img-offer-align">
                            <p class="offering">Insights & Updates </p>
                            <p class="offering-p" > Stay informed with the latest industry trends and news.</p>
                        </div>
                        </div>
                    </div>
                
                    <img src="/assets/images/red-arrow-with-drawings-bulbs (1).jpg" class="reddArrow process-img" alt="about-us-mission" width="300px" height="290px">
                </div>
            </div>
        </div>
      
    </div>
<app-website-footer></app-website-footer>
